// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-editor {
  width: calc(100% - 40px);
  height: calc(100% - 140px);
  padding: 20px;
}
.note-original-text {
  border-left: solid 3px #109870;
  padding-left: 10px;
  margin-bottom: 20px;
  margin-top: 5px;
  line-height: 1.25;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-size: 15px;
}
.editor-box-parent {
  width: 100%;
  height: calc(100% - 15px);
}
.editor-box {
  border: none;
  outline: none;
  resize: none;
  font-size: 15px;
  width: calc(100% - 20px);
  min-height: 120px;
  line-height: 18px;
  overflow-y: scroll;
  background-color: rgba(16, 152, 112, 0.05);
  border-radius: 7px;
  padding: 10px;
}

.editor-box::placeholder {
  font-size: 15px;
  line-height: 15px;
  opacity: 0.6;
  position: relative;
  top: 6px;
  font-weight: 500;
}
.editor-box::-ms-input-placeholder {
  font-size: 15px;
  line-height: 15px;
  opacity: 0.6;
  position: relative;
  top: 6px;
  font-weight: 500;
}
.editor-box::-moz-placeholder {
  font-size: 15px;
  line-height: 15px;
  opacity: 0.6;
  position: relative;
  top: 6px;
  font-weight: 500;
}
.note-button-container {
  position: absolute;
  bottom: 10px;
  right: 10px;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.confirm-button {
  font-size: 15px;
  line-height: 15px;
  opacity: 1;
  cursor: pointer;
}
.cancel-button {
  font-size: 15px;
  line-height: 15px;
  opacity: 1;
  cursor: pointer;
  margin-right: 20px;
}
.note-tags-container {
  overflow-x: auto;
  overflow-y: hidden;
  /* 默认隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

/* 隐藏 WebKit 浏览器的滚动条 */
.note-tags-container::-webkit-scrollbar {
  display: none;
}

/* 悬停时显示滚动条 */
.note-tags-container:hover {
  scrollbar-width: thin; /* Firefox */
  -ms-overflow-style: auto; /* IE/Edge */
}

/* 悬停时显示 WebKit 浏览器的滚动条 */
.note-tags-container:hover::-webkit-scrollbar {
  display: block;
  height: 8px;
}

.note-tags-container:hover::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.note-tags-container:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  height: 4px;
}

.note-tags-container:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupNote/popupNote.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,YAAY;AACxC;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,YAAY;AACxC;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".note-editor {\n  width: calc(100% - 40px);\n  height: calc(100% - 140px);\n  padding: 20px;\n}\n.note-original-text {\n  border-left: solid 3px #109870;\n  padding-left: 10px;\n  margin-bottom: 20px;\n  margin-top: 5px;\n  line-height: 1.25;\n  text-align: left;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  font-size: 15px;\n}\n.editor-box-parent {\n  width: 100%;\n  height: calc(100% - 15px);\n}\n.editor-box {\n  border: none;\n  outline: none;\n  resize: none;\n  font-size: 15px;\n  width: calc(100% - 20px);\n  min-height: 120px;\n  line-height: 18px;\n  overflow-y: scroll;\n  background-color: rgba(16, 152, 112, 0.05);\n  border-radius: 7px;\n  padding: 10px;\n}\n\n.editor-box::placeholder {\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 0.6;\n  position: relative;\n  top: 6px;\n  font-weight: 500;\n}\n.editor-box::-ms-input-placeholder {\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 0.6;\n  position: relative;\n  top: 6px;\n  font-weight: 500;\n}\n.editor-box::-moz-placeholder {\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 0.6;\n  position: relative;\n  top: 6px;\n  font-weight: 500;\n}\n.note-button-container {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  max-width: 100%;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.confirm-button {\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 1;\n  cursor: pointer;\n}\n.cancel-button {\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 1;\n  cursor: pointer;\n  margin-right: 20px;\n}\n.note-tags-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n  /* 默认隐藏滚动条 */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge */\n}\n\n/* 隐藏 WebKit 浏览器的滚动条 */\n.note-tags-container::-webkit-scrollbar {\n  display: none;\n}\n\n/* 悬停时显示滚动条 */\n.note-tags-container:hover {\n  scrollbar-width: thin; /* Firefox */\n  -ms-overflow-style: auto; /* IE/Edge */\n}\n\n/* 悬停时显示 WebKit 浏览器的滚动条 */\n.note-tags-container:hover::-webkit-scrollbar {\n  display: block;\n  height: 8px;\n}\n\n.note-tags-container:hover::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.note-tags-container:hover::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  height: 4px;\n}\n\n.note-tags-container:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
